import React from 'react'
import classnames from 'classnames/bind'

// Components
import Tag from './components/Tag'

// constants
import { isLiveMallClub } from '@/constants/systemType'

// Styles
import styles from './style.module.scss'

// Interfaces
import { ITag } from './components/Tag'

const cx = classnames.bind(styles)

interface ITags {
  tags: ITag[]
  max?: number
}

const Tags = (props: ITags) => {
  const { tags, max } = props
  let tagsData = tags

  if (max) {
    tagsData = tagsData?.slice(0, 3)
  }

  return (
    <div className={cx('tags')}>
      {tagsData?.map((item: ITag, index: number) => (
        <Tag key={index} style={item.style} name={item.name} isLiveMallClub={isLiveMallClub} />
      ))}
    </div>
  )
}

export default Tags
